export default {
  setLocale(state, payload) {
    state.local = payload.locale
  },
  setAvailableLanguages(state, availableLanguages) {
    state.availableLanguages = availableLanguages
  },
  setTranslations(state, payload) {
    state.translations[payload.local] = payload.translations
  }
}
